import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-dialog-new-bank-account',
  templateUrl: './dialog-new-bank-account.component.html',
  styleUrls: ['./dialog-new-bank-account.component.scss']
})
export class DialogNewBankAccountComponent implements OnInit {
  formBankAccount: FormGroup
  modificarDatos: boolean = false;
  lstBancos: any[] = [];
  clabePattern: RegExp = new RegExp('^[0-9]{18}$');
  cuentaPattern: RegExp = new RegExp('^[0-9]{5,50}$');

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogNewBankAccountComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formBankAccount = this.fb.group({
      titular: new FormControl('', [Validators.required, Validators.maxLength(200)]),
      clabe: new FormControl('', [Validators.required, Validators.minLength(18), Validators.maxLength(18), Validators.pattern(this.clabePattern)]),
      noCuenta: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(this.cuentaPattern)]),
      idBanco: new FormControl('', [Validators.required]),
      sucursal: new FormControl('', [Validators.maxLength(50)]),
      default: new FormControl(false)
    });
    if (data && data.attributes) {
      this.modificarDatos = true;
      this.formBankAccount.controls.titular.setValue(data.attributes.titular);
      this.formBankAccount.controls.clabe.setValue(data.attributes.clabe);
      this.formBankAccount.controls.noCuenta.setValue(data.attributes.noCuenta);
      this.formBankAccount.controls.idBanco.setValue(data.attributes.cat_banco?.data?.id);
      this.formBankAccount.controls.sucursal.setValue(data.attributes.sucursal);
      this.formBankAccount.controls.default.setValue(data.attributes.default);
    }
  }

  ngOnInit(): void {
    this.getCatalogoBancos();
  }

  getCatalogoBancos() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService('cat-bancos')
      .subscribe((res: any) => {
        this.lstBancos = res.data;
        this.store.dispatch(OcultarSpinner());
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      })
  }

  addBankAccount() {
    this.formBankAccount.markAllAsTouched();
    this.formBankAccount.updateValueAndValidity();

    if (!this.formBankAccount.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    //Validar clabe 3 primeros digitos
    let miClabe = this.formBankAccount.value.clabe.substr(0, 3);
    //console.log("🚀 ~ DialogNewBankAccountComponent ~ addBankAccount ~ miClabe:", miClabe)
    let cat = this.getBankByClabe(miClabe);
    let bankId = cat?.id || null;
    if (bankId == null || bankId == undefined) {
      return this._snackBar.open(
        'La cuenta clabe ingresada no correponse a ningún banco válido',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea guardar este registro?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let params = {
          data: {
            titular: this.formBankAccount.value.titular,
            clabe: this.formBankAccount.value.clabe,
            noCuenta: this.formBankAccount.value.noCuenta,
            cat_banco: this.formBankAccount.value.idBanco,
            sucursal: this.formBankAccount.value.sucursal,
            default: false,
            ope_empresa: this.data.idEmpresa
          }
        }
        this.store.dispatch(MostrarSpinner());
        this.coalService.postService('ope-empresa-bancos', params)
          .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.close(1);
          }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
          })
      }
    });
  }

  modifyBankAccount() {
    this.formBankAccount.markAllAsTouched();
    this.formBankAccount.updateValueAndValidity();

    if (!this.formBankAccount.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea modificar este registro?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let params = {
          data: {
            titular: this.formBankAccount.value.titular,
            clabe: this.formBankAccount.value.clabe,
            noCuenta: this.formBankAccount.value.noCuenta,
            cat_banco: this.formBankAccount.value.idBanco,
            sucursal: this.formBankAccount.value.sucursal,
            default: false,
            ope_empresa: this.data.idEmpresa
          }
        }
        this.store.dispatch(MostrarSpinner());
        this.coalService.putService(`ope-empresa-bancos/${this.data.id}`, params)
          .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.close(1);
          }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
          })
      }
    });
  }

  close(status) {
    this.dialogRef.close({
      success: status
    });
  }

  textSearchBanco(ctrl: string, event: any) {
    let txt = '' + event.target.value;

    if (ctrl && txt.length >= 3) {
      //Validar clabe 3 primeros digitos
      let miClabe = txt.substr(0, 3);
      let cat = this.getBankByClabe(miClabe);
      let id = cat?.id || null;
      this.formBankAccount.get(ctrl)?.setValue(id);
    }
  }

  getBankByClabe(clabe: string = '') {
    return this.lstBancos.find(x => x.attributes.clave == clabe);
  }
}
